import React from 'react';
import { MapPin, Briefcase, Building } from 'lucide-react';
import { SearchFilters } from '../../types/search';

interface FilterPanelProps {
  filters: SearchFilters;
  onFiltersChange: (filters: SearchFilters) => void;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  onFiltersChange,
}) => {
  const handleLocationChange = (field: 'pays' | 'ville', value: string) => {
    onFiltersChange({
      ...filters,
      location: {
        ...filters.location,
        [field]: value,
      },
    });
  };

  const handleChange = (field: keyof SearchFilters, value: any) => {
    onFiltersChange({
      ...filters,
      [field]: value,
    });
  };

  return (
    <div className="bg-white rounded-lg shadow p-6 space-y-6">
      <h3 className="text-lg font-medium text-gray-900">Filtres</h3>
      
      {/* Localisation */}
      <div className="space-y-4">
        <h4 className="flex items-center text-sm font-medium text-gray-700">
          <MapPin className="h-4 w-4 mr-2" />
          Localisation
        </h4>
        <div className="space-y-2">
          <input
            type="text"
            placeholder="Pays"
            value={filters.location.pays || ''}
            onChange={(e) => handleLocationChange('pays', e.target.value)}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          />
          <input
            type="text"
            placeholder="Ville"
            value={filters.location.ville || ''}
            onChange={(e) => handleLocationChange('ville', e.target.value)}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          />
        </div>
      </div>

      {/* Métier */}
      <div className="space-y-4">
        <h4 className="flex items-center text-sm font-medium text-gray-700">
          <Briefcase className="h-4 w-4 mr-2" />
          Métier
        </h4>
        <input
          type="text"
          placeholder="Ex: Développeur, Designer..."
          value={filters.metier || ''}
          onChange={(e) => handleChange('metier', e.target.value)}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </div>

      {/* Entreprise */}
      <div className="space-y-4">
        <h4 className="flex items-center text-sm font-medium text-gray-700">
          <Building className="h-4 w-4 mr-2" />
          Entreprise
        </h4>
        <input
          type="text"
          placeholder="Nom de l'entreprise"
          value={filters.entreprise || ''}
          onChange={(e) => handleChange('entreprise', e.target.value)}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </div>

      {/* Bouton réinitialiser */}
      <button
        onClick={() => onFiltersChange({
          ...filters,
          location: {},
          metier: '',
          entreprise: ''
        })}
        className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
      >
        Réinitialiser les filtres
      </button>
    </div>
  );
};
